import comp from "./RosterSync";
export default comp;
